import { Switch, Route } from "react-router-dom";
import { useEffect } from "react";
import BootcampStudent from ".";

const BootcampStudentRouter = ({path}) => {
    
    return (
        <Switch>
            <Route 
            exact 
            path={path}
            component={BootcampStudent} />
        </ Switch>
    )
}

export default BootcampStudentRouter